.titleSpan {
  display: block;
  text-align: center;
  font-size: var(--tuna-typography-caption-fontSize);
}
